module.exports = __webpack_public_path__ + "img/must-pass-pop-quiz.da735df4.svg";